import { loadStripe } from '@stripe/stripe-js';

let stripePromise = null;

export function getStripePublishableKey() {
  const key = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
  return typeof key === 'string' ? key.trim() : '';
}

export function isStripeConfigured() {
  return getStripePublishableKey().length > 0;
}

/**
 * Lazy Stripe.js loader. Safe to import anywhere — does not throw when the
 * publishable key env var is missing (common in local dev).
 */
export function getStripe() {
  const key = getStripePublishableKey();
  if (!key) {
    return Promise.resolve(null);
  }
  if (!stripePromise) {
    stripePromise = loadStripe(key);
  }
  return stripePromise;
}
